<ion-app>
  <ion-router-outlet></ion-router-outlet>
  <app-notification-popup [isVisible]="showNotification" #popup></app-notification-popup>
</ion-app>
